<template>
    <section class="flex-container">
        <div class="flex justify-between items-center flex-wrap">
            <div>
                <p class="font-bold">{{ dadosPrestador.nomePrestador }}</p>
                <p v-if="!resumo"><span class="font-bold">CNPJ/CPF: </span>{{ dadosPrestador.documento }}</p>
            </div>
            <div class="w-32 h-20" 
                :style="`background-image: url(${dadosPrestador.logo});background-position: center; background-size: cover; background-repeat: no-repeat;`">
            </div>
        </div>
    </section>
</template>

<script>
import { defineComponent } from 'vue';
import ComponenteDadosAtendimentoService from '@/services/componentes/ComponenteDadosAtendimentoService';

export default defineComponent({
    name: 'DadosPrestador',
    setup() {
        return ComponenteDadosAtendimentoService.setupDadosPrestador();
    },
});
</script>